<template>
  <div class="convention-hall page">
    <!-- 顶部导航栏：添加了左右两侧的图标插槽 -->
    <van-nav-bar class="nav-bar" :border="false">
      <template #left>
        <van-icon name="wap-home-o" class="nav-icon" @click="$router.push('/')" />
      </template>
      <template #right>
        <van-icon name="service-o" class="nav-icon" @click="toService()"/>
      </template>
    </van-nav-bar>

    <!-- 列表主体 -->
    <div class="list-container">
      <van-pull-refresh 
        v-model="isLoading" 
        @refresh="onRefresh"
        pulling-text="kéo xuống để làm mới" 
        loosing-text="thả ra để làm mới" 
        loading-text="đang tải..."
      >
        <!-- 循环渲染游戏项 -->
        <div 
          class="game-card" 
          v-for="(v, index) in gameitem" 
          :key="index" 
          @click="toLottery(v.key, v.id)"
        >
          <!-- 左侧图片 -->
          <div class="card-image-box">
            <img src="/img/game.jpg" style="border-radius: 20px; width: 100px;height: 100px;">
          </div>

          <!-- 右侧文字信息 -->
          <div class="card-info">
            <div class="title">{{ v.name || '상품 열람' + (index + 1) }}</div>
            <div class="subtitle">매회차 {{ v.time || '3' }}분</div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      gameitem: [], // 游戏列表数据
      isLoading: false,
    };
  },
  methods: {
    // 下拉刷新
    onRefresh() {
      this.getGameItem();
    },
    // 跳转详情
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery', query: { key, id } });
      }
    },
    toService() {
				if (this.$store.getters.getBaseInfo.iskefu == 1) {
					this.$router.push("ServiceOnline");
				} else {
					this.$toast.fail(this.$t("setting.forbid"));
				}
			},
    // 获取列表数据
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    }
  },
  created() {
    this.getGameItem();
  }
};
</script>

<style lang='less' scoped>
// 全局页面背景：玫红色
.page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d13a83; // 对应截图中的玫红色背景
  display: flex;
  flex-direction: column;
}

// 导航栏样式
.nav-bar {
  background-color: #e35da1; // 顶部稍浅的粉色
  height: 100px;
  display: flex;
  align-items: center;
  
  /deep/ .van-nav-bar__content {
    width: 100%;
    height: 100px;
  }
  
  .nav-icon {
    font-size: 50px;
    color: #333;
    font-weight: bold;
  }
}

// 列表容器
.list-container {
  flex: 1;
  overflow-y: auto;
  padding: 30px 40px;
  -webkit-overflow-scrolling: touch;
}

// 核心卡片样式
.game-card {
  background-color: #ffffff;
  border-radius: 40px; // 圆角
  padding: 25px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); // 阴影效果

  // 左侧图片容器
  .card-image-box {
    width: 200px;
    height: 200px;
    margin-right: 35px;
    flex-shrink: 0;

    .game-img {
      width: 100%;
      height: 100%;
      background-image: url(/img/page-bg.jpg);
    }
  }

  // 右侧文字容器
  .card-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      font-size: 56px; // 对应截图的大标题
      font-weight: 800;
      color: #e856a6; // 粉色文字
      margin-bottom: 5px;
      line-height: 1.2;
    }

    .subtitle {
      font-size: 38px; // 对应截图的小字
      font-weight: 700;
      color: #e856a6;
      opacity: 0.9;
    }
  }
}

// 去除下拉刷新的背景限制
/deep/ .van-pull-refresh {
  overflow: visible;
}

// 适配不同尺寸
::v-deep .van-image__error, ::v-deep .van-image__loading {
  background-color: #f7f8fa;
  border-radius: 30px;
}
</style>